
import CodeCircle from "../../../assets/outline/CodeCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CodeCircleIcon({ className, dataTestid = "CodeCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CodeCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
